import React from 'react'
import { ReferencePopover } from 'components/ReferencePopover'
import { Info } from 'lucide-react'
import { Box, Text } from '@workwhile/ui'
import { ReferenceTable } from 'components/ReferenceTable'

const viewTypes = [
  {
    key: 'Organic',
    description: 'User discovers the listing from browsing the WorkWhile app',
  },
  {
    key: 'Deeplink',
    description:
      'User discovers the listing from a direct link through SMS or other comms',
  },
]

const ListingDetailViewsReferences = () => {
  return (
    <Box maxWidth={600} color="neutrals.400">
      <Text mb={2}>
        Views are raw events from Amplitude and not deduplicated per user.
      </Text>
      <ReferenceTable title="View types" data={viewTypes} />
    </Box>
  )
}

export const ListingDetailViewsReferencePopover = () => {
  return (
    <ReferencePopover
      trigger={<Info size={14} style={{ marginLeft: 4 }} />}
      subTitle="Reference"
      title="Listing Detail Views"
      contentProps={{
        children: <ListingDetailViewsReferences />,
      }}
    />
  )
}
